<template>
  <div class="">
    <div class="navigate width-a"><span>首页 > </span><span>师资阵容 > </span><span>{{teacherDetail.userName}} > </span></div>
    <div class="content width-a">
      <div class="img-a">
        <img :src="teacherDetail.avatar | fileFilter" alt="">
      </div>
      <div class="left">
        <h1 class="title">{{teacherDetail.userName}}</h1>
        <p class="txt-a">{{teacherDetail.teacherTitle}}</p>
        <p class="txt-c">{{teacherDetail.teacherInstitute}}</p>
        <p class="txt-b">{{teacherDetail.teacherProfile}}</p>
      </div>

    </div>
    <div class="content-c">
      <div class="content-b width-a">
        <video class="img-b" ref="localVideo" :src="teacherDetail.teacherProfileVideo | fileFilter" controls></video>
        <p class="txt-d">{{teacherDetail.teacherCareer}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import CommonFilters from "@/mixins/CommonFilters";
import HttpConnectionC from "@/utils/HttpConnectionC";
export default {
  name: "TeacherDetail",
  mixins: [CommonFilters],
  data () {
    return {
      teacherDetail: {},
      resetTime: 0, // 拖动后重置播放时间
      curTime: 0,  // 当前播放时间
    }
  },
  mounted () {
    let that = this;
    let _id = that.$route.query.userId;
    HttpConnectionC.get(`/homepage/readTeacher/${_id}`).then(function (response) {
      that.teacherDetail = response.data;
    });
    that.fastForward()
  },
  methods: {
    // 禁止快进视频
    fastForward () {
      let that = this;
      let vido = that.$refs.localVideo
      setInterval(() => {
        vido.playbackRate = 1;
      }, 1000);
      // console.log(vido.playbackRate);
      let curTime = 0;  // 当前播放时间
      let vd = that.$refs.localVideo; //获取video对象
      let getCurTime = localStorage.getItem('remTime'); //获取本地存储
      if (getCurTime > 0.1) {
        that.curTime = getCurTime;
        that.resetTime = getCurTime;
        vd.addEventListener('play', function () {
          setTimeout(function () {
            vd.currentTime = getCurTime;
            setInterval(timer, 100)
          }, 2000)
        })
      } else {
        vd.play();
        setInterval(timer, 100)
      }

      // 定时器
      function timer () {
        that.curTime = vd.currentTime;
        let apartTime = that.curTime - that.resetTime;
        if (apartTime > 2) {
          vd.currentTime = that.resetTime;
        } else {
          that.resetTime = that.curTime;
        }
        that.curTime = that.curTime;
      }
      vd.addEventListener('pause', function () {
        localStorage.setItem('remTime', that.curTime);
      })
    }
  }
}
</script>

<style scoped lang="scss">
.navigate {
  font-size: 14px;
  font-weight: 400;
  color: #4d4d4d;
}
.content {
  padding: 40px 0px 0px 0px;
}
.content-b {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.content-c {
  padding: 82px 0px;
  background-color: #f7f8fa;
}
.left {
  width: 1180px;
  padding: 0px 0px 0px 0px;
}
.title {
  font-size: 36px;
  font-weight: 400;
  color: #000000;
  margin: 0px 0px 22px 0px;
}
.txt-a {
  font-size: 24px;
  font-weight: 400;
  color: #4d4d4d;
}
.txt-b {
  font-size: 18px;
  font-weight: 400;
  line-height: 34px;
  color: #666666;
  margin: 22px 0px 60px 0px;
  min-height: 440px;
}
.txt-c {
  font-size: 18px;
  font-weight: 400;
  line-height: 34px;
  color: #666666;
  margin: 22px 0px 0px 0px;
}
.txt-d {
  width: 565px;
  font-size: 18px;
  font-weight: 400;
  line-height: 34px;
  color: #666666;
  margin-left: 20px;
}
.img-a {
  width: 418px;
  height: 440px;
  float: right;
  margin-top: 180px;
  img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }
}
.img-b {
  width: 560px;
  height: 315px;
}
</style>

